<template>
	<v-dialog
			:value="true"
			fullscreen
			persistent
			transition
	>
		<div class="settingUserWrapper">
			<div v-if="step === 0 || step === 4" class="settingUser">
				<div class="settingUser_header">
					<span>{{ id ? "Edit user": "Create new user" }}</span>
					<button type="button" @click="onCloseDialog(null)">
						<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
					</button>
				</div>
				<div class="subTitle">Fill in all the fields</div>
				<field
						:class-error="$v.name.$error"
						margin="0 0 10px 0"
						label="Name"
						placeholder="Enter name"
						@updateInput="onInput($event, 'name')"
						:setInputValue="name"
						is-required
				></field>
				<field
						:class-error="$v.email.$error"
						margin="0 0 10px 0"
						label="Email"
						placeholder="Enter email"
						@updateInput="onInput($event, 'email')"
						:setInputValue="email"
						is-required
				></field>
				<field
						:class-error="getErrorPassword"
						margin="0 0 10px 0"
						label="Password"
						type="password"
						placeholder="Enter password"
						@updateInput="onInput($event, 'password')"
						:setInputValue="password"
						:is-required="!userId"
						is-pass
				></field>
				<field
						:class-error="$v.repeatPassword && $v.repeatPassword.$error"
						margin="0 0 20px 0"
						label="Confirm password"
						type="password"
						placeholder="Enter confirm password"
						@updateInput="onInput($event, 'repeatPassword')"
						:setInputValue="repeatPassword"
						:is-required="!userId"
						is-pass
				></field>
				<v-checkbox
						class="checkbox"
						:input-value="status"
						label="Active"
						color="success"
						hide-details
						@change="onCheckbox($event, 'status')"
				></v-checkbox>
				<div class="employeeBlock" v-if="!isCustomer && (step === 4 || userId) && getNameEmployee">
					Employee: {{ getNameEmployee }}
				</div>
				<div class="employeeBlock" v-if="isCustomer && (step === 4 || userId) && getNameCustomer">
					Customer: {{ getNameCustomer }}
				</div>
				<div class="generateBtn" @click="onGenerateRole">
					<span>Role: {{ getNameRole }}</span>
					<button type="button">{{ step === 4 || id ? 'change': 'generate' }} role</button>
				</div>
				<div class="buttons">
					<button @click="onCloseDialog(null)" class="btn" type="button">CANCEL</button>
					<button :disabled="!userId && step !== 4" @click="onSave" class="btn" type="button">SAVE</button>
				</div>
			</div>

			<div class="selectRoles" v-else>
				<div class="selectRoles_header">
					<span>{{ getTitle }}</span>
					<button type="button" @click="onCloseDialog(null)">
						<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
					</button>
				</div>
				<div class="steps">
					<div class="step">
						<svg-sprite height="32" width="32" :icon-id="getStepSuccess(1)"></svg-sprite>
					</div>
					<div class="divider next"></div>
					<div class="step">
						<span v-if="step < 2">2</span>
						<svg-sprite v-else height="32" width="32" :icon-id="getStepSuccess(2)"></svg-sprite>
					</div>
					<div class="divider"></div>
					<div class="step">
						<span v-if="step < 3">3</span>
						<svg-sprite v-else height="32" width="32" :icon-id="getStepSuccess(3)"></svg-sprite>
					</div>
				</div>
				<div class="stepContent">
					<template v-if="isCustomer">
						<field
								v-if="step === 2 || step === 3"
								:class-error="$v.division_id.$error"
								margin="0 0 10px 0"
								width="100%"
								label="Company"
								placeholder="Select company"
								@updateAutocomplete="onAutocomplete($event, 'division_id')"
								:autocompleteValue="division_id"
								:items="customers"
								:isClearable="false"
								is-autocomplete
								:is-required="step !== 3"
								:is-disabled="step === 3"
						></field>
						<field
								v-if="step === 2 || step === 3"
								margin="0"
								width="100%"
								label="Subrole"
								item-text="name"
								placeholder="Select subrole"
								@updateAutocomplete="onAutocomplete($event, 'subrole')"
								:autocompleteValue="subrole"
								:items="subroleList"
								:isClearable="false"
								is-autocomplete
								:is-disabled="step === 3 || !division_id"
						></field>
					</template>
					<template v-else-if="isDriver">
						<field
								v-if="step === 2 || step === 3"
								:class-error="$v.division_id.$error"
								margin="0 0 10px 0"
								width="100%"
								label="Company"
								placeholder="Select company"
								@updateAutocomplete="onAutocomplete($event, 'division_id')"
								:autocompleteValue="division_id"
								:items="customers"
								:isClearable="false"
								is-autocomplete
								:is-required="step !== 3"
								:is-disabled="step === 3"
						></field>
						<field
								v-if="step === 2 || step === 3"
								margin="0"
								width="100%"
								label="Driver name"
								placeholder="Select driver name"
								@updateAutocomplete="onAutocomplete($event, 'driver_id')"
								:autocompleteValue="subrole"
								:items="driver"
								:isClearable="false"
								is-autocomplete
								:is-disabled="step === 3 || !division_id"
						></field>
					</template>
					<template v-else>
						<field
								v-if="step === 2 || step === 3"
								:class-error="$v.dispatch_id.$error"
								margin="0"
								width="100%"
								label="Employee"
								placeholder="Select employee"
								@updateAutocomplete="onAutocomplete($event, 'dispatch_id')"
								:autocompleteValue="dispatch_id"
								:items="dispatchers"
								:isClearable="false"
								is-autocomplete
								:is-required="step !== 3"
								:is-disabled="step === 3"
						></field>
					</template>
					<field
							v-if="step === 1 || step === 3"
							:class-error="$v.type.$error"
							:margin="step === 3 ? '10px 0' : '0'"
							width="100%"
							:label="getRoleTitle"
							item-text="name"
							placeholder="Select type"
							@updateAutocomplete="onAutocomplete($event, 'type')"
							:autocompleteValue="type"
							:items="typeList"
							:isClearable="false"
							is-autocomplete
							:is-required="step !== 3"
							:is-disabled="step === 3"
					></field>
				</div>
				<div class="buttons">
					<button @click="onBack" class="btn" type="button">BACK</button>
					<button @click="onNext" class="btn green" type="button">{{ step === 3 ? 'confirm': 'NEXT' }}</button>
				</div>
			</div>
		</div>

	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { email, minLength, required, sameAs } from "vuelidate/lib/validators";
export default {
	name: "UserFrom",
	mixins: [ validationMixin ],
	props: {
		userId: Number
	},
	computed: {
		...mapGetters([ 'usersItem' ]),
		isCustomer() {
			return this.type?.type;
		},
		isDriver() {
			return this.type?.id === 35;
		},
		getRoleTitle() {
			return this.isDriver ? 'Role driver' : 'Role';
		},
		getErrorPassword() {
			return this.$v?.password && this.$v?.password.$error;
		},
		getTitle() {
			if (this.step === 2) {
				return this.isCustomer ? "Select subrole" : "Select employee";
			}

			if (this.step === 3) return "Confirmation";

			return "Select role";
		},
		getNameEmployee() {
			return this.dispatch_id?.value ?? null;
		},
		getNameCustomer() {
			return this.division_id?.value ?? null;
		},
		getNameRole() {
			return this.type?.name ?? "no selected";
		}
	},
	data: () => ({
		customers: [],
		dispatchers: [],
		typeList: [],
		subroleList: [],
		driver: null,
		subrole: null,
		type: null,

		name: '',
		email: '',
		password: '',
		repeatPassword: '',
		step: 0,
		dispatch_id: null,
		division_id: null,
		driver_id: null,
		status: false,
		id: null
	}),
	validations() {
		return {
			name: { required },
			email: { email, required },
			type: { required },
			division_id: this.isCustomer || this.isDriver ? { required } : {},
			dispatch_id: this.isCustomer || this.isDriver ? {} : { required },
			password: this.userId ? {} : {
				required,
				minLength: minLength(6),
			},
			repeatPassword: {
				sameAsPassword: sameAs("password")
			}
		};
	},
	methods: {
		...mapActions([ 'onUsersSave', 'setAlert', 'getUsersItem', 'getCompanyUsers' ]),
		onCloseDialog(isRefresh) {
			this.$emit('updateClose', isRefresh);
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onCheckbox(value, key) {
			this[key] = value;
		},
		onGenerateRole() {
			this.step = 1;
		},
		onBack() {
			this.step--;
		},
		onNext() {
			this.$v.$touch();
			const { type, dispatch_id, division_id } = this.$v;
			if (this.step === 1 && type.$error) return false;

			if (this.isCustomer || this.isDriver) {
				if (this.step === 2 && this.step === 2 && division_id.$error) return false;
			} else if (this.step === 2 && dispatch_id.$error) return false;

			this.step++;
		},
		getStepSuccess(step) {
			return this.step === step ? 'stepEdit' : 'stepSuccess';
		},
		onAutocomplete({ value }, key) {
			if (key === "division_id") {
				const { id } = value;
				// this.$emit('updateCompanyUsers', id);
				this.onCompanyUsers(id);
			}

			this[key] = value;
			this.$v.$touch();
		},

		async onCompanyUsers(id) {
			await this.getCompanyUsers(id);

			const { driver } = this.usersItem;

			this.driver = driver;
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const values = {
					name: this.name,
					email: this.email,
					password: this.password,
					status: Number(this.status),
					type: this.subrole?.id || this.type?.id,
					dispatch_id: this.dispatch_id?.id ?? null,
					division_id: this.division_id?.id ?? null
				};

				if (this.isDriver) {
					values.driver_id = this.driver_id?.id ?? null;
				}

				if (this.userId) {
					values.id = this.id;
				}

				const status = await this.onUsersSave(values);

				if (status) {
					this.setAlert({ type: "success", message: "Saving Successfully" });
					this.onCloseDialog(1);
				} else {
					this.setAlert({ type: "error", message: "Saving error" });
				}
			}
		}
	},
	async mounted() {
		await this.getUsersItem(this.userId);

		const { customers, dispatchers, driver, subroleList, type: typeList, users } = this.usersItem;

		this.customers = customers;
		this.dispatchers = dispatchers;
		this.driver = driver;
		this.subroleList = subroleList;
		this.typeList = typeList;

		if (users) {
			const { name, email, status, type: typeId, dispatch_id: dispatchId, id, division_id: divisionId, customer, password_true } = users;
			this.name = name;
			this.email = email;
			this.status = Boolean(status);
			this.password = password_true;
			this.repeatPassword = password_true;
			this.id = id;
			this.type = typeList.find(item => item.id === typeId);

			if (customer) {
				this.division_id = customers.find(item => item.id === divisionId);
				this.$emit('updateSubroleList', divisionId);
				this.subrole = this.subroleList.find(item => item.id === typeId);
			} else {
				this.dispatch_id = dispatchers.find(item => item.id === dispatchId);
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "userForm";
</style>
